import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import api from '../lib/api';
import { sanitizeHtml } from '../lib/sanitize';

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/case-studies/${slug}`); setItem(data); }
      catch { setNotFound(true); }
    })();
  }, [slug]);

  if (notFound) return (
    <div className="pt-32 pb-24 text-center">
      <h1 className="font-serif text-cream-50 text-4xl">Case study not found</h1>
      <Link to="/case-studies" className="mt-6 inline-block text-sage-400 hover:underline">Back to case studies</Link>
    </div>
  );
  if (!item) return <div className="pt-32 text-center text-cream-100/60">Loading...</div>;

  return (
    <div className="pt-24">
      <section className="relative py-28 bg-forest-950">
        {item.cover && <div className="absolute inset-0 opacity-25"><img src={item.cover} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-gradient-to-b from-forest-950 via-forest-950/80 to-forest-900" /></div>}
        <div className="relative max-w-4xl mx-auto px-6 md:px-10">
          <Link to="/case-studies" className="inline-flex items-center gap-2 text-cream-100/70 hover:text-sage-400 text-sm mb-6"><ArrowLeft className="h-4 w-4" /> All Case Studies</Link>
          <p className="text-sage-400 tracking-[0.3em] text-xs uppercase mb-4">{item.service_area}</p>
          <h1 className="font-serif text-cream-50 text-4xl md:text-6xl leading-tight">{item.title}</h1>
          {item.client_type && <p className="mt-4 text-cream-100/60 italic">{item.client_type}</p>}
          <p className="mt-6 text-cream-100/85 text-lg md:text-xl max-w-3xl leading-relaxed">{item.summary}</p>
        </div>
      </section>

      <section className="bg-forest-900 py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-12">
          {[['The Challenge', item.challenge], ['Our Approach', item.approach], ['The Outcome', item.outcome]].map(([h, body]) => body && (
            <div key={h}>
              <h2 className="section-title font-serif text-cream-50 text-3xl md:text-4xl mb-5">{h}</h2>
              <div className="pm-prose text-cream-100/85 text-base md:text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }} />
            </div>
          ))}
        </div>
      </section>

      <section className="bg-forest-950 py-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <p className="text-cream-100/75">Have a similar matter in mind? Speak to our team.</p>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-3 bg-sage-500 text-forest-900 px-8 py-3 text-sm font-medium hover:bg-sage-600 transition-colors">Contact Us <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
